import * as React from "react";

type CalendarForwardProps = {
  fillColor: string;
  pathColor: string;
} & React.SVGProps<SVGSVGElement>;

const CalendarForward = ({
  fillColor,
  pathColor,
  ...props
}: CalendarForwardProps) => (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0.685547}
      y={0.370117}
      width={34.9471}
      height={34.9511}
      rx={6.75}
      fill={fillColor}
      stroke="#DFE4EA"
      strokeWidth={0.5}
    />
    <path
      d="M14.8937 25.1574C14.7204 25.1574 14.5759 25.0996 14.4314 24.984C14.1713 24.7239 14.1713 24.3193 14.4314 24.0592L20.4998 17.8456L14.4314 11.6609C14.1713 11.4008 14.1713 10.9962 14.4314 10.7361C14.6915 10.476 15.096 10.476 15.3561 10.7361L21.8868 17.3832C22.1469 17.6433 22.1469 18.0479 21.8868 18.308L15.3561 24.9551C15.2405 25.0707 15.0671 25.1574 14.8937 25.1574Z"
      fill={pathColor}
    />
  </svg>
);
export default CalendarForward;
